import api from "@/services/api";

const { get, put } = api.getPrefixedMethods("insights");

export const insightsService = {
  getSummary(params) {
    return get("summary", { params });
  },
  getDenials(params) {
    return get("denials", { params });
  },
  getDenialRollups(params) {
    return get("denials/rollups", { params });
  },
  getAccessList() {
    return get("access");
  },
  setAccess(userId, enabled, capability = "view_insights") {
    return put("access", { userId, enabled, capability });
  },
};
